module.exports = __webpack_public_path__ + "static/media/no-metrics-placeholder.0b1cff65.png";